import { PaginatedDataDTO, PaginationDTO, PaginationRestDTO } from '@bottega52/commons-pagination';
import _ from 'lodash';
import { ICustomerContractNotificationRuleInDTO, CustomerContractNotificationRuleAction } from '../repository/jago/model/input/ICustomerContractNotificationRuleInDTO';
import { ICustomerContractNotificationRuleFormDTO } from '../repository/jago/model/input/ICustomerContractNotificationRuleFormDTO';
import { ICustomerContractNotificationRuleOutDTO, ICustomerContractNotificationRuleUpdateOutDTO } from '../repository/jago/model/output/ICustomerContractNotificationRuleOutDTO';

export function decode(data: PaginationRestDTO<ICustomerContractNotificationRuleInDTO>): PaginatedDataDTO<ICustomerContractNotificationRuleInDTO> {
  if (!data || !data.content) {
    return {
      content: [],
      pagination: {
        pageNumber: 0,
        pageSize: 10,
        totalElements: 0,
        totalPages: 0
      }
    };
  }

  const pagination: PaginationDTO = _.omit(data, 'content');
  
  const decodedContent = data.content.map((rule: ICustomerContractNotificationRuleInDTO) => ({
    ...rule,
    id: rule.id || 0,
    customerContractId: rule.customerContractId || 0,
    customerContractName: rule.customerContractName || '',
    customerContractServiceIds: Array.isArray(rule.customerContractServiceIds) ? rule.customerContractServiceIds : [],
    customerContractServiceCodes: Array.isArray(rule.customerContractServiceCodes) ? rule.customerContractServiceCodes : [],
    ruleType: rule.ruleType,
    action: rule.action,
    intervalMonths: rule.intervalMonths || undefined,
    dayOfMonth: rule.dayOfMonth || undefined,
    specificDate: rule.specificDate || undefined,
    nextFireDate: rule.nextFireDate || undefined,
    enabled: rule.enabled !== undefined ? rule.enabled : true,
    emails: Array.isArray(rule.emails) ? rule.emails : [],
    startDate: rule.startDate || 0
  }));

  return {
    content: decodedContent,
    pagination
  };
}

export function decodeCustomerContractNotificationRuleContentToForm(data: ICustomerContractNotificationRuleInDTO, availableServices?: any[]): ICustomerContractNotificationRuleFormDTO {
  const customerContractServices = [];
  
  if (Array.isArray(data.customerContractServiceIds) && Array.isArray(availableServices)) {
    data.customerContractServiceIds.forEach((serviceId, index) => {
      const foundService = availableServices.find(service => service.id === serviceId);
      if (foundService) {
        customerContractServices.push(foundService);
      } else {
        // Fallback: create a minimal service object if not found in available services
        customerContractServices.push({
          id: serviceId,
          code: (data.customerContractServiceCodes && data.customerContractServiceCodes[index]) || '',
          subject: '',
          groupFamily: '',
          type: '',
          sellOutPONumber: '',
          sfdcId: '',
          status: '',
          notes: '',
          activationDate: 0,
          deactivationDate: 0,
          customerId: 0,
          customerName: '',
          customerContractId: data.customerContractId,
          customerContractName: data.customerContractName
        });
      }
    });
  }

  return {
    id: data.id,
    ruleType: data.ruleType,
    intervalMonths: data.intervalMonths,
    dayOfMonth: data.dayOfMonth,
    specificDate: data.specificDate,
    enabled: data.enabled,
    customerContractServices: customerContractServices,
    emails: Array.isArray(data.emails) ? data.emails : [],
    startDate: data.startDate || 0
  };
}

export function encodeCustomerContractNotificationRuleFromForm(data: ICustomerContractNotificationRuleFormDTO): ICustomerContractNotificationRuleOutDTO {
  return {
    ruleType: data.ruleType,
    action: CustomerContractNotificationRuleAction.MAIL,
    intervalMonths: data.intervalMonths,
    dayOfMonth: data.dayOfMonth,
    specificDate: data.specificDate,
    enabled: data.enabled,
    customerContractServiceIds: Array.isArray(data.customerContractServices) ? data.customerContractServices.map(service => service.id) : [],
    emails: Array.isArray(data.emails) ? data.emails : [],
    startDate: data.startDate || 0
  };
}

export function encodeCustomerContractNotificationRuleUpdateFromForm(data: ICustomerContractNotificationRuleFormDTO): ICustomerContractNotificationRuleUpdateOutDTO {
  return {
    ruleType: data.ruleType,
    action: CustomerContractNotificationRuleAction.MAIL,
    intervalMonths: data.intervalMonths,
    dayOfMonth: data.dayOfMonth,
    specificDate: data.specificDate,
    enabled: data.enabled,
    customerContractServiceIds: Array.isArray(data.customerContractServices) ? data.customerContractServices.map(service => service.id) : [],
    emails: Array.isArray(data.emails) ? data.emails : [],
    startDate: data.startDate || 0
  };
} 